/* eslint-disable @nx/enforce-module-boundaries */
import {
  Card,
  Divider,
  HStack,
  Scrollable,
  Stack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Heading,
  Box,
  VStack,
} from '@mybridge/ui';
import { MyProfileCertificate } from 'v4/components/profile/certificates';
import { MyProfileEducation } from 'v4/components/profile/education';
import { MyProfileExperience } from 'v4/components/profile/experience';
import { MyProfileIntroduction } from 'v4/components/profile/introduction';
import { MyProfileMilestone } from 'v4/components/profile/milestones';
import { MyProfilePersonalInfo } from 'v4/components/profile/personal-info';
import { MyProfileSkills } from 'v4/components/profile/skills';
import { MyProfileTestimonial } from 'v4/components/profile/testimonials';

import { useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';
import { MyProfileContext } from 'v4/components/profile/context';
import { MyConnectionsBox } from 'v4/components/profile/my-connections';
import { isMobile } from 'react-device-detect';
import { useRouter } from 'next/router';
import { Text } from '@chakra-ui/react';
export const MyProfileAbout = () => {
  const router = useRouter();
  const { query } = router; // Get query parameters

  // Step 1: Initialize the selected tab index state
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    // Check if the query has "tab=profileDetails"
    if (query.tab === 'profileDetails') {
      setSelectedTabIndex(1); // Set index for "Profile Details" tab
      router.replace('/profile/about', undefined, { shallow: true }); // Immediately remove the "tab" query parameter from the URL
    }
  }, [query, router]);
  const {
    userProfileInfo,
    refetchMyExperiences,
    refetchMySkills,
    refetchMyEducation,
    refetchMyMilestones,
    refetchMyCertificates,
    refetchMyTestimonials,
    refetchMyAnalytics,
  } = useContext(MyProfileContext);

  // console.log('isMobile', mySkills);

  useEffect(() => {
    refetchMyExperiences?.();
    refetchMySkills?.();
    refetchMyEducation?.();
    refetchMyMilestones?.();
    refetchMyCertificates?.();
    refetchMyTestimonials?.();
    refetchMyAnalytics?.();
  }, [userProfileInfo]);

  const tabs = [
    {id:'introduction' ,title: 'Introduction', component: <MyProfileIntroduction /> },
    { id:'profileDetails' ,title: 'Profile Details', component: <MyProfilePersonalInfo /> },
    {id:'experience' , title: 'Experience', component: <MyProfileExperience /> },
    { id:'education' ,title: 'Education', component: <MyProfileEducation /> },
    {id:'skills' , title: 'Skills', component: <MyProfileSkills /> },
    {id:'milestones' , title: 'Milestones', component: <MyProfileMilestone /> },
    { id:'certificationsAndAwards' ,title: 'Certifications and Awards', component: <MyProfileCertificate /> },
    { id:'testimonial' ,title: 'Testimonial', component: <MyProfileTestimonial /> },
  ];
  useEffect(() => {
  const { openDisc, scrollTo } = router.query;

  if (openDisc && scrollTo) {
    const disc = MyProfileContext._currentValue?.[`${openDisc}Disc`];
    disc?.onOpen?.();

    // Retry until the element appears
    let attempts = 0;
    const scrollInterval = setInterval(() => {
      const el = document.getElementById(scrollTo);
      if (el || attempts > 10) {
        clearInterval(scrollInterval);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      attempts++;
    }, 100);
  }
}, [router.query.openDisc, router.query.scrollTo]);

  return (
    // <VStack spacing={6} align="stretch" ml={6}>f
    //   <Heading fontSize="20px" color="brandPrimary.500" fontWeight="400">
    //     About
    //   </Heading>
    //   {tabs.map((tab, index) => (
    //     <Box
    //       key={index}
    //       as="button"
    //       textAlign="left"
    //       onClick={() => setSelectedTabIndex(index)}
    //       p={3}
    //       // borderWidth={1}
    //       borderRadius="md"
    //       bg={selectedTabIndex === index ? 'white' : 'white'}
    //     >
    //       <Heading fontSize="16px" mb={2} color="brandPrimary.700">
    //         {tab.title}
    //       </Heading>
    //       {selectedTabIndex === index && (
    //         <Box mt={2}  p={4} borderRadius="md">
    //           {tab.component}
    //         </Box>
    //       )}
    //     </Box>
    //   ))}
    // </VStack>
    <VStack spacing={3} align="stretch" ml={isMobile?0:6}>
     
      {tabs.map((tab, index) => (
        <Box
          key={index}
          id={tab.id}
          borderRadius="md"
          bg="white"
          // w={isMobile&&"90vw"}
          pl={1}
        >
            <Box mt={[1,30]} borderRadius="md" color="#828282" fontSize="14px" fontWeight="400" >
              {tab.component}
            </Box>
        </Box>
      ))}
    </VStack>
  );

  // return (
  //   <>
  //     {isMobile ? (
  //       <VStack gap={3} p={2}>
  //         <Card variant="thinBorderedCard" p={3} w="100%">
  //           <MyProfileIntroduction />
  //         </Card>
  //         <Card variant="thinBorderedCard" p={3} w="100%">
  //           <MyProfilePersonalInfo />
  //         </Card>
  //         <Card variant="thinBorderedCard" p={3} w="100%">
  //           <MyProfileExperience />
  //         </Card>
  //         <Card variant="thinBorderedCard" p={3} w="100%">
  //           <MyProfileEducation />
  //         </Card>
  //         <Card variant="thinBorderedCard" p={3} w="100%">
  //           <MyProfileSkills />
  //         </Card>
  //         <Card variant="thinBorderedCard" p={3} w="100%">
  //           <MyProfileMilestone />
  //         </Card>
  //         <Card variant="thinBorderedCard" p={3} w="100%">
  //         <MyProfileCertificate />
  //         </Card>
  //         <Card variant="thinBorderedCard" p={3} w="100%">
  //         <MyProfileTestimonial />
  //         </Card>
  //       </VStack>
  //     ) : (
  //       <>
  //         <Card variant="thinBorderedCard" mb={6}>
  //           <Tabs orientation="vertical" variant="verticalVariantAboutUs" index={selectedTabIndex}
  //             onChange={(index) => setSelectedTabIndex(index)}>
  //             <TabList minW="310px">
  //               <Heading
  //                 fontSize="20px"
  //                 color="brandPrimary.500"
  //                 mb={3}
  //                 fontWeight="400"
  //               >
  //                 About
  //               </Heading>
  //               <Tab>Introduction</Tab>
  //               <Tab>Profile Details</Tab>
  //               <Tab>Experience</Tab>
  //               <Tab>Education</Tab>
  //               <Tab>Skills</Tab>
  //               <Tab>Milestones</Tab>
  //               <Tab>Certifications and Awards</Tab>
  //               <Tab>Testimonial</Tab>
  //             </TabList>

  //             <TabPanels>
  //               <TabPanel>
  //                 <MyProfileIntroduction />
  //               </TabPanel>
  //               <TabPanel>
  //                 <MyProfilePersonalInfo />
  //               </TabPanel>
  //               <TabPanel>
  //                 <MyProfileExperience />
  //               </TabPanel>
  //               <TabPanel>
  //                 <MyProfileEducation />
  //               </TabPanel>
  //               <TabPanel>
  //                 <MyProfileSkills />
  //               </TabPanel>
  //               <TabPanel>
  //                 <MyProfileMilestone />
  //               </TabPanel>
  //               <TabPanel>
  //                 <MyProfileCertificate />
  //               </TabPanel>
  //               <TabPanel>
  //                 <MyProfileTestimonial />
  //               </TabPanel>
  //             </TabPanels>
  //           </Tabs>
  //         </Card>

  //         <Box variant="thinBorderedCard" mb={8}>
  //           <MyConnectionsBox limit={4} seeAll orientation="table" />
  //         </Box>
  //       </>
  //     )}  
  //   </>
  // );
};
